const useGtm = () => {
  const trackEvent = (event: string, ...params: any) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      ...params,
    });
  };

  const setDataLayer = (params: any) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(params);
  };

  return {
    setDataLayer,
    trackEvent,
  };
};

export default useGtm;
